import React, { useEffect, useState } from "react";

import { SearchParams } from "../../atomic_components/types";
import { AppDispatch } from "../../state";
import { useDispatch } from "react-redux";
import { ActiveTab__Action } from "../../state/action-creators";
import { useAppSelector } from "../../state/hooks";
import { useHistory, useParams } from "react-router-dom";
import CompanyPurchaseOrdersAdd from "./CompanyPurchaseOrdersAdd";
import CompanyPurchaseOrdersAllPurchaseOrders from "./CompanyPurchaseOrdersAllPurchaseOrders";
import CompanyPurchaseOrdersWIPPurchaseOrders from "./CompanyPurchaseOrdersWIPPurchaseOrders";
import CompanyPurchaseOrdersPartiallyCreatedPurchaseOrders from "./CompanyPurchaseOrdersPartiallyCreatedPurchaseOrders";
// import PurchaseOrdersAdd from "./PurchaseOrdersAdd";
// import PurchaseOrdersOpen from "./PurchaseOrdersOpen";
// import PurchaseOrdersListingView from "./PurchaseOrdersListingView";

interface RouteParams {
  category: string; // Define the type for the parameter you're expecting
}

function CompanyPurchaseOrdersHome() {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const userDetailsFromStore = useAppSelector(
    (state) => state.userdetails_store
  );
  useEffect(() => {
    if (!userDetailsFromStore.authorities.includes("AUTH_ADMIN")) {
      history.push(`/listings/all`);
      return;
    }
    dispatch(ActiveTab__Action("incomingPos"));
  }, []);

  const { category } = useParams<RouteParams>();
  const [selectedItem, setSelectedItem] = useState(category);
  const handleItemClick = (item: string) => {
    setSelectedItem(item);
    history.push(`/incomingPos/${item}`);
  };

  useEffect(() => {
    setSelectedItem(category);
  }, [category]);

  return (
    <div>
      <div className="nav-container">
        <nav className="navbar-vendors">
          <ul className="navbar-menu">
            <li
              className={`navbar-item ${
                selectedItem === "allPos" ? "active" : ""
              }`}
              onClick={() => handleItemClick("allPos")}
            >
              All POs
            </li>

            <li
              className={`navbar-item ${
                selectedItem === "wipPos" ? "active" : ""
              }`}
              onClick={() => handleItemClick("wipPos")}
            >
              Work In Progress POs
            </li>

            <li
              className={`navbar-item ${
                selectedItem === "addPo" ? "active" : ""
              }`}
              onClick={() => handleItemClick("addPo")}
            >
              Add New PO
            </li>

            <li
              className={`navbar-item ${
                selectedItem === "partiallyCreatedPos" ? "active" : ""
              }`}
              onClick={() => handleItemClick("partiallyCreatedPos")}
            >
              Partially Created POs
            </li>
          </ul>
        </nav>
      </div>

      {/* {selectedItem == "all" && <PurchaseOrdersOpen />}
      {selectedItem == "listing-view" && <PurchaseOrdersListingView />}
      {selectedItem == "add" && <PurchaseOrdersAdd />} */}

      {selectedItem === "addPo" && <CompanyPurchaseOrdersAdd />}
      {selectedItem === "wipPos" && <CompanyPurchaseOrdersWIPPurchaseOrders />}
      {selectedItem === "allPos" && <CompanyPurchaseOrdersAllPurchaseOrders />}
      {selectedItem === "partiallyCreatedPos" && (
        <CompanyPurchaseOrdersPartiallyCreatedPurchaseOrders />
      )}
    </div>
  );
}

export default CompanyPurchaseOrdersHome;
